export enum FeedType {
  AllActivity = 'allActivity',
  MyAlerts = 'myAlerts'
}
